<template lang="pug">
  .sidebar(data-color="black")
    .logo
      RouterLink.simple-text.logo-mini(:to="{name: 'home'}")
        img(:src=`require('@/assets/img/header-logo.png')` alt="")
      RouterLink.simple-text.logo-normal(:to="{name: 'home'}")
        | Gorilla Energy Admin
    .sidebar-wrapper(ref="scrollBar")
      ul.nav
        DashboardSidebarItem(
          v-for="(item, i) in acceptedLinks"
          :key="i"
          :item="item"
        )
</template>

<script>
import PerfectScrollbar from 'perfect-scrollbar'
import { mapGetters, mapState } from 'vuex'
import DashboardSidebarItem from './DashboardSidebarItem'
import { getSidebarLinks } from './constants'

export default {
  components: { DashboardSidebarItem },
  data: (vm) => ({
    links: getSidebarLinks(vm)
  }),
  computed: {
    ...mapGetters('auth', ['hasPermission']),
    ...mapState('crumbs', ['crumbs']),
    acceptedLinks: (vm) => vm.links.filter(link => {
      const permissions = link.meta?.permissions || []
      return !permissions.length || permissions.some(permission => vm.hasPermission(permission))
    })

  },
  mounted () {
    return new PerfectScrollbar(this.$refs.scrollBar, {
      suppressScrollX: true
    })
  }
}
</script>
